export default {
  ImportProducts: 'ImportProducts',
  EmailTemplate: 'EmailTemplate',
  UploadProducts: 'UploadProducts',
  Confirmation: 'Confirmation',
  TemplateOptions: 'TemplateOptions'
}
